import styled, { css } from 'styled-components';
import { BUTTONS_TYPE } from '@components/Dialog/constants';

const Buttons = styled.div(
  ({ buttonsType, theme }) => css`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    > * {
      align-self: center;
    }
    ${buttonsType === BUTTONS_TYPE.INLINE &&
      css`
        flex-direction: row;
        > * {
          margin: ${theme.spacing(0, 3, 0, 3)};
        }
      `}
    ${buttonsType === BUTTONS_TYPE.STACKED &&
      css`
        flex-direction: column;
        > *:first-child {
          margin-bottom: ${theme.spacing(8)};
        }
      `};
  `,
);

export default Buttons;
